module.exports = __webpack_public_path__ + "img/hotTit.64fe6af0.jpg";